const FILTERS = {
    "hitachi-advance-server": {
        server_model: {
            title: "Server Model",
            icon: "server.png",
          },
          cpu_generation: {
            title: 'CPU Generation',
            icon: 'os.png'
        },
        operating_system: {
            title: 'Operating System',
            icon: 'os.png'
        }

        
    }}
    export default FILTERS;